var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 34,
    viewBox: "0 0 114 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2759_576)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2.47793V33.8281H17.0984V30.9896H3.73228V2.47793H0.5Z",
    fill: "#161616"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2759_576",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 114,
    height: 34
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0H113.5V34H0.5V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2759_576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.1508 22.1354L75.2799 33.8281H71.2177L60.254 19.6358C62.2632 19.6358 65.2335 19.7629 67.1991 19.1698C70.3441 18.2378 72.528 15.7806 72.528 12.5185C72.528 10.1461 71.174 7.64652 68.99 6.50265C66.9807 5.44355 64.9714 5.31643 62.7 5.31643H57.0653V33.8281H53.833V2.47799H62.0449C64.4909 2.47799 67.7233 2.60505 69.9946 3.66421C73.6201 5.35878 75.7604 8.70563 75.7604 12.6032C75.7604 17.9412 71.5671 21.7964 66.1508 22.1354Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8186 6.03666L91.485 20.4408H104.021L97.8186 6.03666ZM109.962 33.8281L105.288 23.2792H90.262L85.5445 33.8281H82.1812L95.9841 2.47799H99.6095L113.5 33.8281H109.962Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5686 0.171864C46.3414 0.339184 40.0274 5.52876 34.9388 14.3397C33.8691 16.1917 33.0448 18.1001 32.4092 19.9657C31.8875 17.9588 31.1796 15.7841 30.2392 13.8752C27.1486 7.60164 23.1869 4.12498 23.0197 3.98002L21.0391 6.12875C21.0756 6.16036 24.7214 9.35988 27.558 15.1177C29.9085 19.8891 30.6977 26.0786 30.7081 26.1702C30.7081 26.1704 30.7082 26.1706 30.7082 26.1707L30.7287 26.1685C30.1573 30.0823 30.3123 33.5837 30.325 33.8061L33.3009 33.8091C33.2955 33.7117 32.8164 23.9121 37.5314 15.7482C42.293 7.50333 48.316 2.50416 48.365 2.46786L46.5686 0.171864Z",
    fill: "#161616"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2759_576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 34,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ee1ea8eab3e0623ffb913c5e8c7e161e.svg";
export { ForwardRef as ReactComponent };